import React, { useState } from 'react';
import {
	MailContainer,
	StyledTable,
	Line,
	Label,
	Value,
	Textarea,
	ValueWrapper,
	Buttonwrapper,
	EmailResp,
} from './TestMail.styles';
import {
	ApButtonSecondary,
	ApIcon,
	ApInput,
} from '@alixpartners/ui-components';
import { LINK_TYPES } from '../utils';
import { sendMailtoSpendOwners } from 'utils/apiRequests';
import Dropzone from 'react-dropzone';

const TestMail = props => {
	const [testMail, setTestMail] = useState({
		file: '',
		id: '',
		subject: '',
		message: '',
	});
	const [mailResponse, setMailResponse] = useState('');
	const [attachmentUploaded, setAttachmentuploaded] = useState(false);
	const { location } = props;

	const handleChange = (change, changeContent) => {
		if (change === 'ownerId') {
			setTestMail(prevState => ({
				...prevState,
				id: changeContent,
			}));
		} else if (change === 'ownerMessage') {
			setTestMail(prevState => ({ ...prevState, message: changeContent }));
		} else {
			setTestMail(prevState => ({
				...prevState,
				subject: changeContent,
			}));
		}
	};

	const onFileSelected = async acceptedFiles => {
		const payloadFile = acceptedFiles[0];
		setTestMail(prevState => ({ ...prevState, file: payloadFile }));
		setAttachmentuploaded(true);
	};

	const handleEmailSend = (loc, credentials) => {
		const link = loc.pathname.split('/');
		setAttachmentuploaded(false);
		const formData = new FormData();
		formData.append('file', testMail.file);
		// const payload = {
		// 	file: formData,
		// 	emailData: {
		// 		type: 1,
		// 		message: credentials.message,
		// 		linkNumber: LINK_TYPES[link[2]],
		// 		email: credentials.id,
		// 		subject: credentials.subject,
		// 	},
		// };
		formData.append('type', 1);
		formData.append('linkNumber', LINK_TYPES[link[2]]);
		formData.append('message', credentials.message);
		formData.append('email', credentials.id);
		formData.append('subject', credentials.subject);

		sendMailtoSpendOwners(formData).then(response => {
			setTestMail({ id: '', message: '', subject: '', file: '' });
			if (response.succeeded) {
				setMailResponse('Sent successfully');
			} else {
				setMailResponse('Error!');
			}
			setTimeout(
				() => {
					setMailResponse('');
				},
				[4000]
			);
		});
	};

	return (
		<MailContainer>
			<StyledTable>
				<Line>
					<Label>Email</Label>
					<Value>
						<ValueWrapper>
							<ApInput
								value={testMail.id}
								type="text"
								name={'ownerId'}
								onChange={event => handleChange('ownerId', event)}
							/>
						</ValueWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Subject</Label>
					<Value>
						<ValueWrapper>
							<ApInput
								value={testMail.subject}
								type="text"
								name={'ownerSubject'}
								onChange={event => handleChange('ownerSubject', event)}
							/>
						</ValueWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Message</Label>
					<Value>
						<>
							<Textarea
								rows={5}
								value={testMail.message}
								onChange={event =>
									handleChange('ownerMessage', event.target.value)
								}
							/>
						</>
					</Value>
				</Line>
			</StyledTable>
			<Buttonwrapper>
				<div style={{ marginLeft: '10px' }}>
					<Dropzone onDrop={onFileSelected} style={{}} noKeyboard>
						{({ getRootProps, getInputProps }) => (
							<div {...getRootProps()}>
								<input {...getInputProps()} />
								<ApButtonSecondary>
									<ApIcon material iconName="attach_file" />Attachment
								</ApButtonSecondary>
							</div>
						)}
					</Dropzone>
				</div>
				<ApButtonSecondary
					onClick={() => handleEmailSend(location, testMail)}
					disabled={
						testMail.id === '' ||
						testMail.message === '' ||
						testMail.subject === ''
					}
				>
					Send Email
				</ApButtonSecondary>
				<EmailResp>
					{attachmentUploaded ? <ApIcon material iconName="check" /> : null}
					{mailResponse === '' ? null : mailResponse}
				</EmailResp>
			</Buttonwrapper>
		</MailContainer>
	);
};

export default TestMail;
